import * as React from 'react';
import { useCallback, useEffect, useRef, useState } from 'react';
import { HEADER_HORIZONTAL_PADDING, HeaderWidget } from '../widgets/header/HeaderWidget';
import { styled } from '../theme';
import { useSystem } from '../hooks/useSystem';
import { SmartDropdownWidget } from './SmartDropdownWidget';
import { useWindowSize } from '../hooks/useWindowSize';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { autorun } from 'mobx';
import { ProfileSidebarItems } from '../pages/profile/ProfileLandingPage';

export const SmartHeaderWidget: React.FC<React.PropsWithChildren<{}>> = observer((props) => {
  const system = useSystem();
  const navigate = useNavigate();

  const [showUserMenu, setShowUserMenu] = useState(false);

  const profileRef = useRef();
  const clickOutsideCB = useCallback(() => {
    setShowUserMenu(false);
  }, []);

  const windowSize = useWindowSize();

  useEffect(() => {
    system.notificationStore.init();
    system.profileStore.loadInvitations();
  }, []);

  useEffect(() => {
    // listen to notifications
    let l: (() => any)[] = [];

    const disposeListeners = () => {
      l.forEach((l) => l());
    };

    const disposeAutorun = autorun(() => {
      disposeListeners();
      l = system.notificationStore.notifications.map((n) => {
        return n.registerListener({
          navigate: (url) => {
            navigate(url);
          }
        });
      });
    });
    return () => {
      disposeListeners();
      disposeAutorun();
    };
  }, []);

  return (
    <S.Container>
      {showUserMenu && (
        <SmartDropdownWidget
          pos={{ x: windowSize.width - 136 - HEADER_HORIZONTAL_PADDING, y: 58 }}
          targetRefs={[profileRef]}
          onClickOutside={() => clickOutsideCB()}
          items={[
            ...ProfileSidebarItems.map(({ path, label }) => {
              return {
                label: label,
                action: async () => {
                  navigate(path);
                  setShowUserMenu(false);
                }
              };
            }),
            {
              label: 'Sign out',
              action: async () => {
                setShowUserMenu(false);
                await system.accountsPortalClient.logout();
                (window.location as any) = `${system.context.ACCOUNTS_URL}/users/sign_out`;
              }
            }
          ]}
        />
      )}
      <HeaderWidget
        title={props.children}
        name={system.context.USER_NAME!}
        email={system.context.USER_EMAIL}
        profileRef={showUserMenu ? profileRef : undefined}
        onProfileClick={() => {
          setShowUserMenu(!showUserMenu);
        }}
        notifications={system.notificationStore.notifications}
      />
    </S.Container>
  );
});

namespace S {
  export const Container = styled.div`
    position: relative;
  `;
}
